import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_location",
  "use": "icon-icon_location-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_location\"><defs><style></style></defs><path d=\"M1011.302 12.698a25.6 25.6 0 0 0-28.262-5.53L20.48 422.708a25.6 25.6 0 0 0 1.434 48.332l384.41 143.36 147.66 389.12a25.6 25.6 0 0 0 23.347 16.589 25.6 25.6 0 0 0 23.962-16.589l415.539-962.56a25.6 25.6 0 0 0-5.53-28.262zM880.64 107.315L423.322 564.634 99.532 444.416zM579.174 925.082l-122.88-322.15 460.39-459.572z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol